import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixPopover from '@radix-ui/react-popover';
import { useRef } from 'react';
import { styled } from 'styletron-react';
import { getSpacing } from '../../const/spacing';
import { zIndexes } from '../../const/zIndexes';
import { Card } from '../Card/Card';
import { Box } from '../layout/Box';
const StyledContent = styled(RadixPopover.Content, (p) => {
    const maxHeight = p.$overrideMaxHeight
        ? p.$overrideMaxHeight
        : 'var(--radix-popover-content-available-height)';
    const overflow = p.$maxAvailableHeight || !!p.$maxAvailableHeight ? 'auto' : undefined;
    return {
        width: p.$sameWidthAsAnchor
            ? 'var(--radix-popover-trigger-width)'
            : undefined,
        maxHeight,
        overflow,
        // To fix cut shadows
        paddingLeft: getSpacing('1/2'),
        paddingRight: getSpacing('1/2'),
        paddingTop: 0,
        paddingBottom: getSpacing('1/2'),
        zIndex: zIndexes.anchoredPopover,
    };
});
export const Popover = ({ children, anchor, open, sameWidthAsAnchor = false, align, onContentOpenAutoFocus, onContentMouseDown, onClose, maxAvailableHeight = true, overrideMaxHeight, onInteractOutside, }) => {
    const isMouseOverAnchor = useRef(false);
    const handleOpenChange = (newOpen) => {
        if (!newOpen && !isMouseOverAnchor.current)
            onClose?.();
    };
    const handleMouseEnterAnchor = () => {
        isMouseOverAnchor.current = true;
    };
    const handleMouseLeaveAnchor = () => {
        isMouseOverAnchor.current = false;
    };
    return (_jsxs(RadixPopover.Root, { open: open, onOpenChange: handleOpenChange, children: [_jsx(RadixPopover.Anchor, { onMouseEnter: handleMouseEnterAnchor, onMouseLeave: handleMouseLeaveAnchor, children: anchor }), _jsx(RadixPopover.Portal, { children: _jsx(StyledContent, { $sameWidthAsAnchor: sameWidthAsAnchor, $maxAvailableHeight: maxAvailableHeight, $overrideMaxHeight: overrideMaxHeight, align: align, onOpenAutoFocus: onContentOpenAutoFocus, onMouseDown: onContentMouseDown, onInteractOutside: onInteractOutside, children: _jsx(Box, { spacingTop: '1/2', children: _jsx(Card, { children: children }) }) }) })] }));
};
